import {SvgIconData} from '@shared-web/components/core/svg_icon';

export const magicIcon: SvgIconData = {
  viewBox: '5.9 5 88.2 90',
  element: (
    <path d="M20 95c1.7-7.9 5.9-13.4 14-15.7-3.6-1.7-7-3.1-9.5-6-2.4-2.9-3.4-6.4-4.7-9.8-1.3 8.2-6.1 13.1-14 15.8A19 19 0 0 1 20 95m54.3-5.7C76.5 78 82.6 70.7 94.1 68c-11.5-2.8-17.7-10.2-19.8-21.7-2 11.7-8.2 19-19.8 21.7C66 70.6 72.2 78.1 74.3 89.3m-33-31.8c2.4-14 9.8-23 24-26.2C51 27.9 43.6 18.8 41.2 5q-3 21.3-23.9 26.4c14.3 3.2 21.6 12.2 24 26.1" />
  ),
};
